export { cardDefinitionsDe } from './card_definitions_de'
export { cardDefinitionsEn } from './card_definitions_en'
export { cardMatchesContext } from './card_helper'


// WEBPACK FOOTER //
// ./src/all_cards/index.js